module.exports = __webpack_public_path__ + "img/output-2.913a4de1.png";